'use client'

import SectionSwiper from '@component/layout/section/swiper'
import useAddOpenhome from '@hooks/useAddOpenhome'
import useFetch from '@hooks/useFetch'
import useLogin from '@hooks/useLogin'
import getRouter, { URLS } from '@router'
import { getTime, joinStr } from '@utils'
import { get, includes, size } from 'lodash-es'
import DisablePrefetchLink from '@component/disablePrefetchLink'
import { useUnmount } from 'react-use'

export default function OpenHomeLayout({
  title = '',
  data,
  house,
  isOpenHome = false,
  isAuction = false,
  className = ''
}) {

  const { hideAddOpenhome } = useAddOpenhome()
  useUnmount(() => {
    hideAddOpenhome()
  })
  return (
    <div className={className}>
      <div className='flex items-center gap-x-4'>
        <span className='text-xl font-medium'>{title}</span>
        <span className='-translate-y-1/4 bg-secondary min-w-[20px] h-20 rounded-half flex items-center justify-center text-sm text-white'>{size(data)}</span>
      </div>
      <div className='mt-16'>
        <SectionSwiper
          data={data}
          dataKey='id'
          Card={OpenHomeCard}
          cardParams={{ house, isOpenHome, isAuction }}
          showNext={false}
          slidesPerView='auto'
          slidesPerGroup={1}
          breakpoints={{}}
          slideClassName='!w-auto'
        />
      </div>
    </div>
  )
}

function OpenHomeCard({
  data,
  house,
  isOpenHome,
  isAuction
}) {
  return (
    <div className='border rounded-sm'>
      <div className='p-14'>
        <div className='text-base font-normal'>{getTime(data.start, 'ddd, D MMM')}</div>
        <div className='text-sm whitespace-nowrap'>{joinStr([getTime(data.start, 'hh:mmA'), data.end ? getTime(data.end, 'hh:mmA') : ''], ' - ')}</div>
      </div>
      <div className='px-14 py-8 border-t'>
        <AddButton data={data} house={house} isOpenHome={isOpenHome} isAuction={isAuction}>+ Add to planner</AddButton>
      </div>
    </div>
  )
}

function AddButton({
  data,
  house,
  online = false,
  children,
  isOpenHome,
  isAuction
}) {

  const { isLogin } = useLogin()
  const { showAddOpenhome, showAddAuction, openhomeLoading, openhomeSaved } = useAddOpenhome()
  const isLoading = get(openhomeLoading, data.id, false)
  const { houseId } = house

  const { data: status } = useFetch(
    isLogin
      ? { url: 'property/user/state', params: { houseId, propertyId: house.propertyId }, cfCache: false }
      : null
  )

  const saved = (isOpenHome && includes(get(status, 'openHomes', []), data.id) || openhomeSaved[data.id]) || (isAuction && get(status, 'auction', false))
  return (
    saved
      ? <DisablePrefetchLink href={getRouter(URLS.profileJourney, undefined, { start: data.start })} className='button-text-primary !text-sm'>View in planner</DisablePrefetchLink>
      : (
        <button
          onClick={
            isOpenHome
              ? showAddOpenhome({ openhome: data, house, online })
              : isAuction
                ? showAddAuction({ auction: data, house, online })
                : undefined
          }
          className='button-text-primary !text-sm'
        >
          {
            isLoading
              ? 'loading...'
              : children
          }
        </button>
      )
  )
}
